import React from 'react'

import Image from './Image'
import './Card.css'
import ALink from './ALink'
import { Link } from 'gatsby'

export const Card = ({
  type,
  featuredImage,
  title,
  content,
  categories = [],
  slugText,
  slug
}) => {
  return (
    <>
      <div className={`Card ${type} relative`}>
        <Link to={slug} className="absolute" />
        {featuredImage && (
          <div className="Card--Image relative">
            <Image background src={featuredImage} alt={title} />
          </div>
        )}
        <div className="Card--Content">
          <header>
            <div className="Card--Tag">
              {categories && categories.map(cat => cat.category).join(', ')}
            </div>
            <h2 className="Card--Title">{title}</h2>
          </header>
          {content && type !== 'Mini' ? <p>{content}</p> : null}
          <ALink slug={slug} text={slugText} />
        </div>
      </div>
    </>
  )
}

export default Card
